import React, { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import ReinforcerWeightGraph from 'src/assets/images/reinforcer-weight-graph.png';
import { ReinforceFatLossWithTarget } from './ReinforceFatLossWithTarget';
import { getGoalSummary } from './utils';

interface ReinforcerWeightGoalProps {
  buttonClick: () => void;
  buttonText: string;
  isWithTargetWeight: boolean;
  goalId: number;
  targetWeight: number;
  currentWeight: number;
}

export const ReinforcerWeightGoal: FC<ReinforcerWeightGoalProps> = props => {
  const {
    buttonClick,
    buttonText,
    isWithTargetWeight,
    goalId,
    targetWeight,
    currentWeight,
  } = props;

  const { rateString } = getGoalSummary({
    targetWeight,
    goal: goalId,
    currentWeight,
  });

  if (isWithTargetWeight) {
    return (
      <ReinforceFatLossWithTarget
        buttonClick={buttonClick}
        buttonText={buttonText}
        goalId={goalId}
        targetWeight={targetWeight}
        currentWeight={currentWeight}
      />
    );
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 1,
        }}>
        <Box
          sx={{
            width: '100%',
            maxWidth: '420px',
            display: 'flex',
            flexDirection: 'column',
          }}>
          <Box
            sx={{
              display: 'flex',
              flex: { xs: 3, md: 1 },
              flexDirection: 'column',
              alignItems: { xs: 'flex-start', md: 'center' },
              justifyContent: 'space-between',
              padding: '20px',
            }}>
            <Typography
              sx={{
                fontSize: '22px',
                fontWeight: '500',
                marginTop: 4,
                color: 'white',
                marginBottom: 4,
              }}>
              By consistently following the Equ program, we expect a{' '}
              {rateString} loss per week. We also embrace non-scale victories on
              your journey!
            </Typography>
            <img
              src={ReinforcerWeightGraph}
              alt="graph"
              style={{ margin: '10px 0px', width: '90%' }}
            />
            <Button
              variant="contained"
              onClick={buttonClick}
              size="large"
              sx={{
                textTransform: 'none',
                borderRadius: '100px',
                marginTop: 4,
                width: '330px',
                height: '55px',
                alignSelf: 'center',
                marginBottom: 2,
              }}>
              {buttonText}
            </Button>
          </Box>
        </Box>
      </Box>
    </>
  );
};
